import { FormattedMessage as FM } from "react-intl";

/**
 * Define cell for row
 * @param {Boolean} selectable - optional selectable
 * @param {Boolean} editable - optional default true
 * @param {Function} onClick - callback function on click cell
 * @param {ChildNode} Component - Component to render as child
 * @param {String} textAling - optional align text for cell [left, right, center] default center
 * @param {String} color - define color for cell
 * @param {Array} style - define style for cell
 */
const style =
  "sticky top-0 whitespace-nowrap py-2 px-2 text-sm text-center font-normal text-stone-700";

function HeaderCell({
  index,
  field,
  handleSort,
  layout,
  // orderField,
  // orderDirection,
}) {
  const { model } = layout;

  return (
    <th
      key={index}
      scope="col"
      onClick={() => handleSort(field.name)}
      className={style}
    >
      <FM id={`${model}.${field.name}`} />
    </th>
  );
}

export default HeaderCell;
